import Hero from "../components/Hero";
import ManagementLab from "../components/ManagementLab";
import Features from "../components/Features";
import Testimonials from "../components/Testimonials";
import Metrics from "../components/Metrics";
import CTASection from "../components/CTASection";
import ContactForm from "../components/ContactForm";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <ManagementLab />
      <Features />
      <Testimonials />
      <Metrics />
      <CTASection />
      <ContactForm />
    </main>
  );
}
